"use client";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div style={{ padding: 24, fontFamily: "system-ui, sans-serif" }}>
      <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>
        Es ist ein Fehler aufgetreten
      </h2>
      <p style={{ color: "#666", marginBottom: 16 }}>
        {process.env.NODE_ENV === "production"
          ? "Bitte versuche es später erneut."
          : error?.message ?? "Unbekannter Fehler"}
      </p>
      <button
        onClick={() => reset()}
        style={{
          padding: "8px 12px",
          background: "#4f46e5",
          color: "#fff",
          borderRadius: 6,
          border: "none",
          cursor: "pointer",
        }}
      >
        Erneut versuchen
      </button>
    </div>
  );
}
